import { render } from "./InvoicesDeclinedTable.vue?vue&type=template&id=12a21684"
import script from "./InvoicesDeclinedTable.vue?vue&type=script&lang=js"
export * from "./InvoicesDeclinedTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__